const allocation = `${process.env.VUE_APP_URL}/api/v1/allocation/`;
const cost = `${process.env.VUE_APP_URL}/api/v1/cost/`;
const activities = `${process.env.VUE_APP_URL}/api/v1/activities/`;
const allocationCalculation = `${process.env.VUE_APP_URL}/api/v1/calculation`;
import { validateResponseError } from "@/store/utils.js";
export default {
  namespaced: true,
  state: {
    management: {
      baseUrl: ({ scenario, limit, order, offset, searchTerm }) => `${allocation}direct-cost-pool-percentage-allocations/?scenario=${scenario}&limit=${limit}${order}${offset}${searchTerm}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [
        {
          label: "Cost Pool Source",
          field: "source_name",
        },
        {
          label: "Activity Destination",
          field: "destination_name",
        },
        {
          label: "Allocation type",
          field: "allocation_type",
        },
        {
          label: "Ratio",
          field: "ratio",
          type: 'percentage',
        },
        {
          label: "TDABC Ratio",
          field: "tdabc_ratio",
          type: 'percentage',
          hidden: false,
          thClass: 'tdabc-background-header',
          tdClass: 'tdabc-background',
        },
        {
          label: "",
          field: "manage",
        },
      ],
      rows: [],
      orderField: '',
      orderDict: {
        source_name: "source__name",
        destination_name: "destination__name",
        allocation_type: "allocation_type",
        ratio: "ratio"
      },
    },
    source: {
      baseUrl: ({ scenario, limit, offset }) => `${allocationCalculation}/direct-results/by-source/?scenario=${scenario}&limit=${limit}${offset}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [
        {
          label: "Cost pool name",
          field: "source_name",
        },
        {
          label: "Original amount",
          field: "original_amount",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; }
        },
        {
          label: "Allocated amount",
          field: "allocated_amount",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; }
        },
        {
          label: "Capacity",
          field: "capacity",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; },
          hiden:false,
          thClass: 'tdabc-background-header',
          tdClass: 'tdabc-background',
        },
        {
          label: "Status",
          field: "status",
        }
      ],
      rows: [],
      orderField: '',
    },
    destination: {
      baseUrl: ({ scenario, limit, offset }) => `${allocationCalculation}/direct-results/by-destination/?scenario=${scenario}&limit=${limit}${offset}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [
        {
          label: "Activity",
          field: "destination_name",
        },
        {
          label: "Amount",
          field: "amount",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; }
        },
        {
          label: "Capacity",
          field: "capacity",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; },
          hidden: false,
          thClass: 'tdabc-background-header',
          tdClass: 'tdabc-background',
        }
      ],
      rows: [],
      orderField: '',
    },
    aggregated: {
      baseUrl: ({ scenario, limit, offset }) => `${allocationCalculation}/direct-results/?scenario=${scenario}&limit=${limit}${offset}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [
        {
          label: "Source",
          field: "source_name",
        },
        {
          label: "Destination",
          field: "destination_name",
        },
        {
          label: "Allocated amount",
          field: "amount",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; }
        },
        {
          label: "Allocated Capacity",
          field: "capacity",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; },
          hidden: false,
          thClass: 'tdabc-background-header',
          tdClass: 'tdabc-background',
        }
      ],
      rows: [],
      orderField: '',
    },
    tdabcResults:{
      baseUrl: ({ scenario, limit, offset }) => `${allocationCalculation}/direct-results/time-driven/?scenario=${scenario}&limit=${limit}${offset}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [
        {
          label: "Destination",
          field: "destination",
        },
        {
          label: "Cost per Minute",
          field: "cost_per_unit",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; },
          thClass: 'tdabc-background-header',
          tdClass: 'tdabc-background',
        }
      ],
      rows: [],
      orderField: '',

    },
    tableRows: [],
    tableColumns: [

    ],

    sourceAllocationResultsColumns: [

    ],
    sourceAllocationResultsRows: [],

    destinationAllocationResultsColumns: [
    ],
    destinationAllocationResultsRows: [],

    aggregatedAllocationResultsRows: [],
    aggregatedAllocationResultsColumns: [

    ],
    lastCalculation: [{
      calculation_id: null,
      finished_at: null, 
      requested_by_user: null,
    }],

    createAllocationData: {
      source: null,
      destination: null,
      percentage: 100
    },

    directCostPoolOptions: [],
    activityOptions: [],

    strategyOptions: [
      {
        id: "not_allocate",
        name: "Not allocate"
      },
      {
        id: "rebalance",
        name: "Rebalance"
      }
    ],
    resultsStrategy: "not_allocate", //rebalance
    debug:{
      mode: "logs",
      errors:[],
      logs:[]
    }
  },
  getters:{
    getDebugData(state){
      return state.debug[state.debug.mode];
    }
  },
  mutations: {
    SET_SEARCH_TERM(state, data){
      state[data.subStore].searchTerm = data.searchTerm
    },
    SET_OFFSET(state, data) {
      state[data.subStore].offset = state[data.subStore].pageLength * data.currentPage - state[data.subStore].pageLength < 0 ? 0 : state[data.subStore].pageLength * data.currentPage - state[data.subStore].pageLength
    },
    SET_DEBUG_LOGS(state, data){
      state.debug.logs = data;
    },
    SET_DEBUG_ERRORS(state, data){
      state.debug.errors = data;
    },
    SET_DEBUG_MODE(state, data){
      state.debug.mode = data;
    },
    SET_COSTPOOL_OPTIONS(state, data) {
      if (!data) {
        return;
      }
      state.costPoolOptions = data
      state.directCostPoolOptions = data.filter(el => el.is_direct)
    },
    SET_ACTIVITIES_OPTIONS(state, data) {
      state.activityOptions = data;
    },
    SET_ALLOCATION_DATA(state, data) {
      state.createAllocationData.id = data.id;
      state.createAllocationData.source = data.source;
      state.createAllocationData.destination = data.destination;
      state.createAllocationData.percentage = data.percentage * 100;
    },
    SET_ALLOCATION_SOURCE(state, data) {
      let allocationData = { ...state.createAllocationData }
      allocationData.source = data;
      state.createAllocationData = allocationData;
    },
    SET_ALLOCATION_DESTINATION(state, data) {
      let allocationData = { ...state.createAllocationData }
      allocationData.destination = data;
      state.createAllocationData = allocationData;
    },
    SET_ALLOCATION_PERCENTAGE(state, data) {
      let allocationData = { ...state.createAllocationData }
      allocationData.percentage = data;
      state.createAllocationData = allocationData;
    },
    SET_RESULTS_STRATEGY(state, data) {
      state.resultsStrategy = data;
    },
    SET_LAST_CALCULATION(state, data) {
      if (!data) {
        return;
      }
      state.lastCalculation = data;
    },
    CLEAR_RESULTS_DATA(state) {
      state.source.rows = [];
      state.destination.rows = [];
      state.lastCalculation = [{
        calculation_id: null,
        finished_at: null
      }]
    },
    /////////////////////////////////////////////////////////////////////////
    SET_COUNT(state, data) {
      state[data.subStore].count = data.count;
    },
    SET_NEXT(state, data) {
      state[data.subStore].nextUrl = data.next;
    },
    SET_PREVIOUS(state, data) {
      state[data.subStore].previousUrl = data.previous;
    },
    SET_CURRENT(state, data) {
      state[data.subStore].currentUrl = data.current;
    },
    SET_ROWS(state, data) {
      if (!data.rows) {
        return;
      }
      let copy = { ...state[data.subStore] }
      copy.rows = data.rows;
      state[data.subStore] = copy;
    },
    SET_MANAGEMENT_COLUMNS_TDABC(state, data) {
      console.log("SET_MANAGEMENT_COLUMNS_TDABC", data)
      state.management.columns.forEach(element => {
        if (element.label == "TDABC Ratio") { element.hidden = !data }
      });
    },
    SET_AGGREGATED_COLUMNS_TDABC(state, data) {
      state.aggregated.columns.forEach(element => {
        if (element.label == "Allocated Capacity") { element.hidden = !data }
      });      
    },
    SET_SOURCE_COLUMNS_TDABC(state, data) {
      state.source.columns.forEach(element => {
        if (element.label == "Capacity") { element.hidden = !data }
      });      
    },
    SET_DESTINATION_COLUMNS_TDABC(state, data) {
      state.destination.columns.forEach(element => {
        if (element.label == "Capacity") { element.hidden = !data }
      });      
    },
    SET_PAGE_LENGTH(state, data) {
      state[data.subStore].pageLength = data.pageLength;
    },
    CLEAR_TABLE_DATA(state, data) {
      if (data.subStore) {
        state[data.subStore].rows = [];
      }
    },
    SET_ORDER_FIELD(state, data) {
      if (data.subStore && state[data.subStore].orderDict) {
        switch (data.orderType) {
          case 'asc':
            state[data.subStore].orderField = state[data.subStore].orderDict[data.orderField];
            break;
          case 'desc':
            let orderField = state[data.subStore].orderDict[data.orderField]
            state[data.subStore].orderField = orderField ? `-${orderField}` : null;
            break;
          default:
            state[data.subStore].orderField = null;
            break;
        }
      }
    }

  },
  actions: {
    getTableData({ state, commit }, { context, scenarioId, subStore, isTdabc }) {
      let order = state[subStore].orderField ? `&ordering=${state[subStore].orderField}` : ''
      let offset = state[subStore].offset ? `&offset=${state[subStore].offset}` : ''
      let searchTerm = state[subStore].searchTerm ? `&search=${state[subStore].searchTerm}` : ''
      let getData =
        state[subStore].currentUrl || state[subStore].baseUrl({ scenario: scenarioId, limit: state[subStore].pageLength, order: order, offset: offset, searchTerm: searchTerm});
      return context.$http.get(getData).then((res) => {
        commit("SET_COUNT", { subStore, count: res.data.count });
        commit("SET_NEXT", { subStore, next: res.data.next });
        commit("SET_PREVIOUS", { subStore, previous: res.data.previous });
        if(subStore === "management") {commit("SET_MANAGEMENT_COLUMNS_TDABC", isTdabc)};
        if(subStore === "aggregated") {commit("SET_AGGREGATED_COLUMNS_TDABC", isTdabc)};
        if(subStore === "source") {commit("SET_SOURCE_COLUMNS_TDABC", isTdabc)};
        if(subStore === "destination") {commit("SET_DESTINATION_COLUMNS_TDABC", isTdabc)};
        commit("SET_ROWS", { subStore, rows: res.data.count ? res.data.results : res.data });
        res.data.results.forEach(element => element.allocation_type = "percentage")
      });
    },
    setNextAsCurrent({ state, commit }, { subStore }) {
      commit("SET_CURRENT", { subStore, current: state[subStore].nextUrl });
    },
    setPreviousAsCurrent({ state, commit }, { subStore }) {
      commit("SET_CURRENT", { subStore, current: state[subStore].previousUrl });
    },
    deleteAllocation({ state }, { context, id, type }) {
      let deleteUrl = `${allocation}direct-cost-pool-${type}-allocations/${id}/`;
      return context.$http.delete(deleteUrl);
    },
    getCostPools({ commit }, { context, scenarioId }) {
      let getUrl = `${cost}pools/?scenario=${scenarioId}`;
      return context.$http.get(getUrl)
        .then((res) => {
          commit("SET_COSTPOOL_OPTIONS", res.data);
        });
    },
    getActivities({ commit }, { context, modelId }) {
      let getUrl = `${activities}?model=${modelId}`;
      return context.$http.get(getUrl)
        .then((res) => {
          commit("SET_ACTIVITIES_OPTIONS", res.data);
        });
    },
    createUpdateThirdAllocation({ state }, { context, scenarioId, mode }) {
      let dataToPost = { ...state.createAllocationData };
      dataToPost.ratio = (dataToPost.percentage / 100).toFixed(6);
      dataToPost.scenario = scenarioId

      if (mode == "UPDATE") {
        let putUrl = `${allocation}direct-cost-pool-percentage-allocations/${state.createAllocationData.id}/`;
        return context.$http.patch(putUrl, dataToPost);
      }

      let postUrl = `${allocation}direct-cost-pool-percentage-allocations/`;
      return context.$http.post(postUrl, dataToPost);
    },

    // CALCULATIONS
    getLastCalculationDetails({ commit, dispatch }, { context, scenarioId }) {
      let resultsUrl = `${allocationCalculation}/calculations/?scenario=${scenarioId}&category=DIRECT_COST_POOL_TO_ACTIVITY`;
      return context.$http.get(resultsUrl)
        .then(res => {
          commit("SET_LAST_CALCULATION", res.data)
          if (res.data[res.data.length - 1].calculation_status !== "FINISHED") {
            throw new Error("No calculation");
          }
        })
        .catch(err => {
          validateResponseError(this, err, "thirdAllocation");
        })
    },
    getLastCalculation({ commit, dispatch }, { context, scenarioId }) {
      let resultsUrl = `${allocationCalculation}/calculations/?scenario=${scenarioId}&category=DIRECT_COST_POOL_TO_ACTIVITY`;
      return context.$http.get(resultsUrl)
        .then(res => {
          commit("SET_LAST_CALCULATION", res.data)
          if (res.data[res.data.length - 1].calculation_status !== "FINISHED") {
            throw new Error("No calculation");
          }
        }).catch(err => {
          validateResponseError(this, err, "thirdAllocation");
        })
    },
    calculateResults({ state, dispatch, commit }, { context, scenarioId }) {
      commit("CLEAR_RESULTS_DATA");
      let resultsUrl = `${allocationCalculation}/direct-results/generate/`;
      return context.$http.post(resultsUrl, { scenario: scenarioId })
        .then(res => {
          commit("SET_LAST_CALCULATION", [res.data])
        });
    },
    getSourceAllocationResults({ dispatch }, { context, scenarioId }) {
      dispatch("getTableData", { context, subStore: "source", scenarioId: scenarioId })
    },
    getDestinationAllocationResults({ dispatch }, { context, scenarioId }) {
      dispatch("getTableData", { context, subStore: "destination", scenarioId: scenarioId })
    },
    getAggregatedAllocationResults({ dispatch }, { context, scenarioId }) {
      dispatch("getTableData", { context, subStore: "aggregated", scenarioId: scenarioId })
    },
    getCalculationLogs({commit, state},{context}){
      let resultUrl = `${process.env.VUE_APP_URL}/api/v1/calculation/logs/?calculation=${state.lastCalculation[0].calculation_id}`
      return context.$http.get(resultUrl)
        .then(res => {
          commit("SET_DEBUG_LOGS", res.data[0].detail )
        }).catch(err => {
          validateResponseError(this, err, "thirdAllocation");
        })
    },
    getCalculationErrors({commit},{}){
      commit("SET_DEBUG_ERRORS",["Not implemented"]);
    },
    cancelCalculation({ dispatch, commit }, { context, scenarioId, calculationID }) {
      commit("CLEAR_RESULTS_DATA");
      let resultsUrl =  `${allocationCalculation}/calculations/stop-calculation/`;
      let payload = {
        calculation_id: calculationID
      }
      return context.$http.post(resultsUrl, payload)
      .then(() => {
        return dispatch("getLastCalculationDetails",{context:context, scenarioId: scenarioId})
      });
    },
  },
}
